<a [finLink]="url" class="block nordic-blue-900-text medium-type no-underline" data-test-link-cta>
  <span>{{ text }}</span>
  <fcom-icon name="arrow-right"></fcom-icon>
</a>
